var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.component !== null)?_c(_vm.component.name,_vm._b({tag:"component"},'component',_vm.component.props,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }